import { createAsyncThunk, original } from "@reduxjs/toolkit";
import { CommonAxiosResponse, thunkResponseHandler } from "common";
import {
  UserSocialDataPayload,
  UserSocialLoginResponse,
  UserSocialResponse,
  userLoginPayload,
} from "./types";
import { PcwSocialProfileApi } from "./api";
import modules from "modules";

export const pcwUserSocialCallback = createAsyncThunk<
  CommonAxiosResponse<UserSocialResponse>,
  UserSocialDataPayload
>("PcwUserSocial/pcwUserSocialCallback", async (data) => {
  const res = await PcwSocialProfileApi.userSocialCallback(data);
  const toThunk = await thunkResponseHandler(res);
  return toThunk;
});

export const pcwUserSocialLogin = createAsyncThunk<
  CommonAxiosResponse<UserSocialLoginResponse>,
  userLoginPayload
>("PcwUserSocial/pcwUserSocialLogin", async (data, { dispatch }) => {
  const res = await PcwSocialProfileApi.userSocialLogin(data);
  const toThunk = await thunkResponseHandler(res);
  const dataToken = {
    token_type: "Bearer",
    expires_in: "604800000 ",
    access_token: toThunk?.originalData?.token,
  };
  const { actions: AccessTokenAction } = modules.oauth;
  if (toThunk?.success) {
    dispatch(AccessTokenAction.clientTokenResolve(dataToken));
  }
  return toThunk;
});
